import { useEffect, useRef } from 'react';

import { buildSeededForm, collectEditedFieldNames } from '../Content.utils';

export const usePostClosingFormSeed = ({
  form,
  initialFormValues,
  setInitialFormValues,
  setForm,
}) => {
  const formDataRef = useRef({});
  const editedFieldNamesRef = useRef(new Set());
  const seededValuesRef = useRef(initialFormValues);

  useEffect(() => {
    editedFieldNamesRef.current = collectEditedFieldNames({
      editedFieldNames: editedFieldNamesRef.current,
      form,
      seededValues: seededValuesRef.current,
    });
    formDataRef.current = { ...formDataRef.current, ...form };
  }, [form]);

  useEffect(() => {
    seededValuesRef.current = initialFormValues;
    setInitialFormValues(initialFormValues);
    setForm(
      buildSeededForm({
        initialFormValues,
        preservedValues: formDataRef.current,
        editedFieldNames: editedFieldNamesRef.current,
      }),
    );
  }, [initialFormValues, setInitialFormValues, setForm]);

  return formDataRef;
};
